<template>
   <!-- This component is not in use yet, as we're still rendering one in AccountPage.vue
   It will be enabled once Account Page CMS is ready (BLU-211) -->

   <!-- Link to External Contributions page (if feature is turned on) -->
   <!-- These are contributions that a user has made on another platform before using a portal -->
   <LinkButton
      v-if="clientSettings.externalContributions.isActive"
      styleType="outlined"
      :color="Theme.BrandDark"
      url="/contributions"
      data-cy="user-contributions"
   >
      {{ subsection.buttonText }}
   </LinkButton>
</template>
<script setup lang="ts">
import { type SpecialSubsection } from "./accountTypes";
import { useClientSettingsKey } from "@/plugins/useClientSettings";
import { Theme } from "@/types";

const clientSettings = inject(useClientSettingsKey);

// Props
// ------------------------------------
const props = defineProps<{
   subsection: SpecialSubsection;
}>();
</script>
